import { useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDqDLh-9LgWjIU3XW0sdaAzpRuF9mNjBVw",
  authDomain: "thebigbatproject.firebaseapp.com",
  projectId: "thebigbatproject",
  storageBucket: "thebigbatproject.firebasestorage.app",
  messagingSenderId: "445232420746",
  appId: "1:445232420746:web:3b84caeaf6ee7c0d6f5a73",
  measurementId: "G-MJ62MQ5QKE",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export const useUploadStatusListener = (uploadId, onComplete) => {
  useEffect(() => {
    if (!uploadId) return;
    const docRef = doc(db, "uploads", uploadId);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists() && docSnap.data().status === "complete") {
        onComplete && onComplete();
        unsubscribe();
      }
    });
    return () => unsubscribe();
  }, [uploadId, onComplete]);
};
